import { decorate, action } from "mobx"
import autoBind from "auto-bind"
import {
  FIELD_TYPES, TASK_NAMES,
} from "../lib/constants";

import { fitResponseToFunctions } from "../lib/utils";
class ChatFunctionsStore {

  constructor(appStore) {
    this.appStore = appStore;
    autoBind(this)
  }

  getTasksForSingleAndMultipleSheets(params, fns) {
    let tasks = [];

    if (params.packName) {
      tasks.push({
        type: TASK_NAMES.createPacks,
      });
      this.appStore.chatTaskStore.setPacks([{ packName: params.packName }])
    }

    if (fns[TASK_NAMES.createSheets] && fns[TASK_NAMES.createSheets].length) {
      tasks.push({
        type: TASK_NAMES.createSheets,
      });
      this.appStore.chatTaskStore.setSheets(fns[TASK_NAMES.createSheets])
    }

    if (fns[TASK_NAMES.createSubsheets]) {
      tasks.push({
        type: TASK_NAMES.createSubsheets,
      });
      this.appStore.chatTaskStore.setSubsheets(fns[TASK_NAMES.createSubsheets])
    }

    if (
      fns[TASK_NAMES.addLookupFields] &&
      fns[TASK_NAMES.addLookupFields].length
    ) {
      tasks.push({
        type: TASK_NAMES.addLookupFields,
      });
      this.appStore.chatTaskStore.setFields(fns[TASK_NAMES.addLookupFields], FIELD_TYPES.lookup)
    }

    if (
      fns[TASK_NAMES.addFormulaFields] &&
      fns[TASK_NAMES.addFormulaFields].length
    ) {
      tasks.push({
        type: TASK_NAMES.addFormulaFields,
      });
      this.appStore.chatTaskStore.setFields(fns[TASK_NAMES.addFormulaFields], FIELD_TYPES.formula)
    }

    if (
      fns[TASK_NAMES.createSheets] &&
      fns[TASK_NAMES.createSheets].length
    ) {
      tasks.push({
        type: TASK_NAMES.createDummyData,
      })
    }

    if (fns[TASK_NAMES.createSheets] && fns[TASK_NAMES.createSheets].length) {
      tasks.push({
        type: TASK_NAMES.sheetsNavigation,
      });
    }

    return tasks;

  }

  async createSheet(params) {
    try {
      const fns = {};
      fitResponseToFunctions({ sheets: [params] }, fns);
      const tasks = this.getTasksForSingleAndMultipleSheets(params, fns);

      this.appStore.chatTaskStore.setTasks(tasks);
      this.appStore.chatTaskStore.updateTaskIndex(0);
    } catch (e) {
      console.log(`e->`, e);
      this.appStore.chatStore.addChatMessage({
        role: "assistant",
        type: "message",
        content: e.message,
      });
    }
  };

  async createSheets(params) {
    try {
      const fns = {};
      fitResponseToFunctions(params, fns);
      const tasks = this.getTasksForSingleAndMultipleSheets(params, fns);
      this.appStore.chatTaskStore.setTasks(tasks);
      this.appStore.chatTaskStore.updateTaskIndex(0);
    } catch (e) {
      console.log(`e->`, e);
      this.appStore.chatStore.addChatMessage({
        role: "assistant",
        type: "message",
        content: e.message,
      });
    }
  };

  async addColumnsToASheet(params) {
    try {
      await this.appStore.assistantStore.fetchAndLoadPacks();
      const pack = this.appStore.assistantStore.packsById[params.packId || window.PACK?.id];

      if (!pack)
        throw new Error("The pack id doesn't exist")

      await this.appStore.assistantStore.fetchAndLoadSheets();
      const sheet = this.appStore.assistantStore.sheetsById[params.sheetId];

      if (!sheet)
        throw new Error("The sheet id doesn't exist")

      const fns = {};
      fitResponseToFunctions({ sheets: [params] }, fns);

      const tasks = [];

      this.appStore.chatTaskStore.setPacks([pack])
      this.appStore.chatTaskStore.setSheets([sheet])

      if (fns[TASK_NAMES.createSubsheets]) {
        tasks.push({
          type: TASK_NAMES.createSubsheets,
        });
        this.appStore.chatTaskStore.setSubsheets(fns[TASK_NAMES.createSubsheets])
      }

      if (
        fns[TASK_NAMES.addGeneralFields] &&
        fns[TASK_NAMES.addGeneralFields].length
      ) {
        tasks.push({
          type: TASK_NAMES.addGeneralFields,
        });

        // group fields by their fieldType
        for (const { fields, ...restItem } of fns[TASK_NAMES.addGeneralFields]) {

          // group all fields by their field type
          const fieldsByFieldType = {};
          for (const field of fields) {
            if (!fieldsByFieldType[field.field_type_id]) {
              fieldsByFieldType[field.field_type_id] = [];
            }
            fieldsByFieldType[field.field_type_id].push(field);
          }

          for (const fieldType in fieldsByFieldType) {
            // save grouped fields (per sheet) to task store
            this.appStore.chatTaskStore.addFields(
              [{ fields: fieldsByFieldType[fieldType], ...restItem }],
              fieldType
            );
          }
        }
      }

      if (
        fns[TASK_NAMES.addLookupFields] &&
        fns[TASK_NAMES.addLookupFields].length
      ) {
        tasks.push({
          type: TASK_NAMES.addLookupFields,
        });
        this.appStore.chatTaskStore.addFields(fns[TASK_NAMES.addLookupFields], FIELD_TYPES.lookup)
      }

      if (
        fns[TASK_NAMES.addFormulaFields] &&
        fns[TASK_NAMES.addFormulaFields].length
      ) {
        tasks.push({
          type: TASK_NAMES.addFormulaFields,
        });
        this.appStore.chatTaskStore.addFields(fns[TASK_NAMES.addFormulaFields], FIELD_TYPES.formula)
      }

      tasks.push({
        type: TASK_NAMES.sheetsNavigation,
      });

      this.appStore.chatTaskStore.setTasks(tasks);
      this.appStore.chatTaskStore.updateTaskIndex(0);

    } catch (e) {
      console.log(`e->`, e);
      this.appStore.chatStore.addChatMessage({
        role: "assistant",
        type: "message",
        content: e.message,
      });
    }
  };

  async shareSheet(params) {
    try {

      const tasks = [];
      const { sheetId, role, emails } = params;
      this.appStore.chatTaskStore.setSheetIds([sheetId])
      this.appStore.chatTaskStore.setRoles([role])
      this.appStore.chatTaskStore.setEmails([...emails])
      tasks.push({
        type: TASK_NAMES.shareSheet,
      });

      this.appStore.chatTaskStore.setTasks(tasks);
      this.appStore.chatTaskStore.updateTaskIndex(0);
    } catch (error) {
      this.appStore.chatStore.addChatMessage({
        role: "assistant",
        type: "message",
        content: "Some error occurred while sharing the sheet. You can still share it manually by going into settings > sheet permissions. ",
      });
    }
  }


}

decorate(ChatFunctionsStore, {
  addColumnsToASheet: action,
  createSheet: action,
  createSheets: action,
  shareSheet: action,
})

export default ChatFunctionsStore;